import React from "react";
import "./BenefitsCard.scss";
import Button from "components/Button/Button";
import Cards from "components/Cards/Cards";

interface BenefitsCardProps {
  btnName: string;
  blocksArr: {
    title: string;
    description: string;
  }[];
  onClick: () => void;
}

const BenefitsCard = ({ btnName, blocksArr, onClick }: BenefitsCardProps) => {
  return (
    <div className="benefits-card">
      <div className="card-main-title">{btnName}</div>
      <Button className={"darck-btn"} btnName={btnName} onClick={onClick} />
      <Cards cardsArr={blocksArr} />
    </div>
  );
};

export default BenefitsCard;
